<template>
	<div class="filter-wrapper" :class="{'active-filter': activeFilter, 'active-cloud': activeCloud}" @click="clickFilter">
		<div class="filter">
			<AppClickableIcon
				class="filter-button"
				icon-name="iconPlus"
				:auto-set-active="false"
				@click="clickIcon"
			/>
			<p>{{ text }}</p>
		</div>
		<AppInPlaceCloud @close-cloud="closeCloud" ref="cloud" :active="activeCloud">
			<p class="cloud-title">{{fieldName}}</p>
			<slot></slot>
			<div class="row centered flex-end mt-10">
				<AppButton small @click="clickApply" :text="getString('apply')" />
			</div>
		</AppInPlaceCloud>
	</div>
</template>

<script>
import AppClickableIcon from "@/shared/components/AppClickableIcon.vue";
import AppInPlaceCloud from "@/shared/components/AppInPlaceCloud.vue";
import AppButton from "@/shared/components/AppButton.vue";

import {useSvgStore} from "@/shared/stores";
import {useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		const svgStore = useSvgStore();
		const languageStore = useLanguageStore();
		return { getIcon: svgStore.get, getString: languageStore.getString }
	},
	components: {
		AppClickableIcon,
		AppInPlaceCloud,
		AppButton,
	},
	name: "AppFilter",
	emits: ["apply-filter", "click-icon", "filter-clicked"],
	data() {
		return {
			activeCloud: false,
			closeCloudListener: null,
		}
	},
	props: {
		fieldName: {type: String, default: ""},
		text: {type: String, default: ""},
		activeFilter: {type: Boolean, default: false},
		toggleCloudPopup: {type: Boolean, default: true},
	},
	methods: {
		closeCloud() {
			if(!this.toggleCloudPopup){ return; }

			if(this.closeCloudListener) {
				document.removeEventListener('click', this.closeCloudListener);
				this.closeCloudListener = null;
			}
			if(this.activeCloud) { this.activeCloud = false; }
		},
		elementIsInCloud(element) {
			if(!this.$refs['cloud'] || !this.$refs['cloud'].$refs || !this.$refs['cloud'].$refs['cloud']) { return false; }
			let maxIterations = 50;
			let currentIterations = 0;
			while (element.parentElement && currentIterations <= maxIterations) {
				if(element === this.$refs['cloud'].$refs['cloud']) {
					return true;
				}
				element = element.parentElement;
				currentIterations++;
			}
			return false;
		},
		clickFilter(e) {
			if(!this.toggleCloudPopup) {
				this.$emit("filter-clicked");
				return;
			}

			let closeCloudListener = (e2)=>{
				if(!this.elementIsInCloud(e2.target) && e !== e2) {
					this.closeCloud();
				} else {
					document.addEventListener('click', this.closeCloudListener, {once: true});
				}
			}
			if(!this.elementIsInCloud(e.target)) {
				this.activeCloud = !this.activeCloud;
				if(this.activeCloud) {
					if(!this.closeCloudListener) {
						this.closeCloudListener = closeCloudListener;
						document.addEventListener('click', this.closeCloudListener, {once: true});
					}
				} else {
					this.closeCloud();
				}
			}
		},
		clickApply() {
			this.closeCloud();
			this.$emit("apply-filter");
		},
		clickIcon(e) {
			if(!this.toggleCloudPopup && !this.activeFilter) {
				this.$emit("click-icon");
				return;
			}

			if(this.activeCloud) {
				e.stopPropagation();
				this.closeCloud();
			}
			if(this.activeFilter) {
				e.stopPropagation();
				this.$emit("click-icon");
			}
		},
	},
}
</script>

<style lang="scss" scoped>

.filter-wrapper {
	cursor: pointer;
	display: flex;
	align-items: center;
	margin-right: 10px;
	position: relative;

	.in-place-cloud {
		z-index: 10000;
		min-width: 150px;

		.cloud-title {
			@include noSelect;
			color: $txt_1;
			font-size: 14px;
			line-height: 18px;
			margin-bottom: 10px;
			font-weight: 700;
		}

		:deep(.input-wrapper) {
			width: unset;
		}
	}

	.filter {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 1px 11px 1px 7px;
		border-radius: 13px;
		font-size: 14px;
		line-height: 18px;
		user-select: none;
		position: relative;
		transition: border .2s ease;
		border: 1px dashed var(--color-txt-1);

		p {
			font-size: 14px;
			color: var(--color-txt);
		}

		.filter-button {
			margin-right: 5px;
			padding: 2px;
			display: flex;
			align-items: center;
			transition: transform .2s ease;
			width: 22px;

			:deep(svg) {

				.fill {
					fill: var(--color-primary);
				}

				.stroke {
					stroke: var(--color-primary);
				}
			}
		}

		@media (max-width: 480px) {
			p {
				font-size: 12px;
			}
		}
	}

	&:hover, &.active-cloud {
		.filter {
			border: 1px solid var(--color-txt-2);
		}
	}

	&.active-filter {
		.filter {
			border: 1px solid rgba(61, 61, 61, 0.15);
			background-color: var(--color-bg-primary-2);
		}
		.filter-button {
			transform: rotate(45deg);

			&:hover {
				transform: rotate(45deg) scale(1.2);
			}
		}
	}
}

</style>